export default function navigationLinksReducer(state = {
  navigationLinks: [],
  fetching: false,
  fetched: false,
  errors: {},
  loginStatuses: [],
  permissions: {},
}, action) {
  switch (action.type) {
    case 'GET_NAVIGATIONLINK_LIST_PENDING':
    case 'GET_NAVIGATIONLINK_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'INITIALIZE_ADD_NAVIGATIONLINK_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'GET_NAVIGATIONLINK_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        navigationLinks: action.payLoad.data,
      };
    }
    case 'REORDER_NAVIGATIONLINKS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        navigationLinks: action.payLoad.data,
      };
    }
    case 'GET_NAVIGATIONLINK_LIST_REJECTED':
    case 'GET_NAVIGATIONLINK_REJECTED': {
      return {...state, errors: action.payLoad.errors};
    }
    case 'INITIALIZE_ADD_NAVIGATIONLINK_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        loginStatuses: action.payLoad.login_statuses,
        permissions: action.payLoad.permissions,
      };
    }
    case 'GET_NAVIGATIONLINK_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        navigationLink: action.payLoad.data,
      };
    }
    case 'DELETE_NAVIGATIONLINK_FULFILLED': {
      const newState = {...state};
      newState.navigationLinks = newState.navigationLinks.filter(navigationLink => navigationLink.id !== action.payLoad);
      return newState;
    }
    case 'CLEAR_EDIT_NAVIGATIONLINK': {
      return {
        ...state,
        navigationLink: {
          attributes: {
            permissions: {}
          }
        }
      };
    }
    default:
  }

  return {...state};
}
